<template>
    <div class="mt-2 p-4 bg-white rounded-lg">
        <div class="pb-2.5" v-if="policyDetail.main_class == '2'">
            <div class="text-16 font-medium text-a-black-555555 leading-22px">ข้อมูลความคุ้มครอง</div>
            <div class="pt-2 text-12 text-a-black-484848 leading-4.5">
                <div class="flex justify-between">
                    <div>ทุนประกัน</div>
                    <div>{{ policyDetail.coverage.insured_value }}</div>
                </div>
                <div class="flex justify-between pt-2">
                    <div>ค่าเสียหายส่วนแรก</div>
                    <div>{{ policyDetail.coverage.damages }}</div>
                </div>
                <div class="flex justify-between pt-2 gap-4">
                    <div class="flex-shrink-0">ความคุ้มครอง Top up</div>
                    <div v-html="newLine(policyDetail.coverage.protection_top_up)"></div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="text-16 font-medium text-a-black-555555 leading-22px">ข้อมูลความคุ้มครอง</div>
            <div v-for=" item in policyDetail.coverage" :key="item.value">
                <div class="pt-2 text-12 text-a-black-484848 leading-4.5">
                    <div class="grid grid-cols-4">
                        <div class=" col-start-1 col-span-3">{{ item.label }}</div>
                        <div class=" col-start-4 text-right" v-html="newLine(item.detail)"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Util from '@/helper/Utility';
export default {
    name: 'ProtectionInfo',
    props: {
        policyDetail: Object
    },
    methods: {
        newLine: function(str) {
            return Util.newLineToBr(str)
        }
    }
}
</script>


